import React, { useEffect, useRef, useState } from "react";
import Link from "next/link";
import Image from "next/image";
import * as Text from "@/components/text";
import useWindowSize from "@/hooks/useWindowSize";
import Metadata from "@/components/film/Metadata";
import Button from "@/components/actions/Button";
import { localeTexts } from "@/utils/locale";
import { useRouter } from "next/router";

export default function FeaturedTitleCustom({
  trailer_link = "",
  active,
  film_name,
  original_title,
  film_cover,
  initiatives,
  setColor,
  directors,
  film_year,
  countries,
  film_length,
  slug,
  awards,
  film_metadata = {
    duration: "100",
    year: "2020",
    countries: ["Mexico, Argentina"],
  },
}) {
  const windowSize = useWindowSize();
  const [width, setWidth] = useState(0);
  const router = useRouter();
  const [locale, setLocale] = useState("es-MX");

   useEffect(() => {
   if (!router.isReady) return;
   const urlLocale = router.query.locale;
   const storedLocale = typeof window !== "undefined"
   ? localStorage.getItem("amb-locale")
   : null;
   
   const finalLocale = urlLocale || storedLocale || "es-MX";
   setLocale(finalLocale);
   localStorage.setItem("amb-locale", finalLocale);
   }, [router.isReady, router.query.locale]);

  useEffect(() => {
    if (active) {
      setColor(initiatives?.data[0]?.id || 0);
    }
  }, [active, initiatives, setColor]);

  const miRef = useRef();

  return (
    <div
      className={"sm:w-[100%] md:max-h-[448px] lg:max-w-[795px]"}
      ref={miRef}
    >
      <div
        className={
          width < 300
            ? "top-0 z-0 h-[168px]"
            : width < 490
              ? "top-0 z-0 sm:h-[168px] sm:w-[328px] md:h-[200px] md:w-full lg:h-[260px]"
              : "top-0 z-0  md:h-[448px] lg:h-[536px] lg:max-h-[536px]"
        }
      >
        <Image
          fill={true}
          className="h-full w-full object-cover object-center"
          src={
            film_cover?.data?.attributes?.url ||
            "https://images.unsplash.com/photo-1658686873732-c93680078088?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1287&q=80"
          }
          alt="Film picture"
        />
      </div>

      <div
        className={
          width < 795
            ? "absolute bottom-5 z-10 ml-5 space-y-1"
            : "absolute bottom-10 z-10 ml-10 space-y-1"
        }
      >
        <Text.Headline
          className="text-white"
          as="h2"
          size={windowSize.width || width < 720 ? "xs" : "xl"}
        >
          {film_name}
        </Text.Headline>
        <Text.Body
          as="div"
          className={"font-bold` text-white last:after:content-[''] "}
          size="sm"
        >
          {directors?.map(({ Director, id }, i) => (
            <span className=" pr-2" key={id}>
              {Director} {i === directors.length - 1 ? null : ","}
            </span>
          ))}
        </Text.Body>
        {/* Meta */}
        <div className="meta-same-h">
          <Metadata
            film_metadata={{
              duration: film_length,
              year: film_year ? film_year[0]?.year : "",
              countries:
                countries?.length > 0
                  ? [countries?.map((c) => c.countries).join(", ")]
                  : "",
            }}
            className={"text-neutral-100"}
            theme="dark"
            size="md"
          />
        </div>
        <div>
          <Link href={`/catalogo/${slug}`}>
            <Button color="terciary-dark" label={localeTexts[locale].FeaturedTitleCustom.Button} />
          </Link>
        </div>
      </div>
    </div>
  );
}
